import { ConsignmentSpecies, DeviceResponseStatus } from './enums';

export function speciesEnumToName(speciesEnum: ConsignmentSpecies | string | null) {
    switch (speciesEnum) {
        case ConsignmentSpecies.GOAT:
            return 'Goat';
        case ConsignmentSpecies.BOBBY_CALVES:
            return 'Bobby Calves';
        case ConsignmentSpecies.CATTLE:
            return 'Cattle';
        case ConsignmentSpecies.SHEEP_LAMB:
            return 'Sheep/Lamb';
        default:
            return;
    }
}

export function speciesEnumToPluralName(speciesEnum: ConsignmentSpecies | string | null) {
    switch (speciesEnum) {
        case ConsignmentSpecies.GOAT:
            return 'Goats';
        case ConsignmentSpecies.BOBBY_CALVES:
            return 'Bobby Calves';
        case ConsignmentSpecies.CATTLE:
            return 'Cattle';
        case ConsignmentSpecies.SHEEP_LAMB:
            return 'Sheep/Lambs';
        default:
            return;
    }
}

export const ALL_SPECIES = [
    ConsignmentSpecies.BOBBY_CALVES,
    ConsignmentSpecies.CATTLE,
    ConsignmentSpecies.GOAT,
    ConsignmentSpecies.SHEEP_LAMB,
];

export enum ConsignmentStatus {
    DRAFT = 'DRAFT',
    SUBMITTED = 'SUBMITTED',
    LOCKED = 'LOCKED',
    DELETED = 'DELETED',
    // ENVDB-7836: the API and the gateway (GraphQLGateway/DTO/Consignment.cs) have always had this;
    // the display mappings below deliberately do not cover it — that is ENVDB-6805's scope.
    UNLOCKED = 'UNLOCKED',
}

export enum GraphqlErrorType {
    Error = 'Error',
    Warning = 'Warning',
    Success = 'Success',
}

export enum UserRole {
    AUTHVIEWER = 'AUTHVIEWER',
}

export function consignmentEnumToName(statusEnum: ConsignmentStatus | string | null) {
    switch (statusEnum) {
        case ConsignmentStatus.DRAFT:
            return 'Draft';
        case ConsignmentStatus.SUBMITTED:
            return 'Submitted';
        case ConsignmentStatus.LOCKED:
            return 'Completed';
        case ConsignmentStatus.UNLOCKED:
            return 'Unlocked';
        case ConsignmentStatus.DELETED:
            return 'Deleted';
        default:
            return;
    }
}

export function consignmentEnumToColor(statusEnum: ConsignmentStatus | string | null) {
    switch (statusEnum) {
        case ConsignmentStatus.DRAFT:
            return 'muted';
        case ConsignmentStatus.SUBMITTED:
            return 'normal';
        case ConsignmentStatus.LOCKED:
            return 'success';
        case ConsignmentStatus.UNLOCKED:
            return 'normal';
        case ConsignmentStatus.DELETED:
            return 'error';
        default:
            return;
    }
}

export function deviceStatusEnumToColor(statusEnum: DeviceResponseStatus) {
    switch (statusEnum) {
        case DeviceResponseStatus.INACTIVE:
            return 'muted';
        case DeviceResponseStatus.ACTIVE:
            return 'success';
        case DeviceResponseStatus.NOT_FOUND:
            return 'error';
        case DeviceResponseStatus.UNAUTHORIZED:
            return 'warning';
        default:
            return;
    }
}

export function deviceStatusEnumToName(statusEnum: DeviceResponseStatus) {
    switch (statusEnum) {
        case DeviceResponseStatus.INACTIVE:
            return 'Inactive';
        case DeviceResponseStatus.ACTIVE:
            return 'Active';
        case DeviceResponseStatus.NOT_FOUND:
            return 'Not found';
        case DeviceResponseStatus.UNAUTHORIZED:
            return 'Unauthorised';
        default:
            return;
    }
}

export function mapConsignmentToDeviceSpecies(consignmentSpecies: ConsignmentSpecies): string {
    switch (consignmentSpecies) {
        case ConsignmentSpecies.SHEEP_LAMB:
            return 'Sheep';
        case ConsignmentSpecies.GOAT:
            return 'Goats';
        case ConsignmentSpecies.CATTLE:
            return 'Cattle';
        case ConsignmentSpecies.BOBBY_CALVES:
            // ENVDB-8077: NLIS has no bobby-calf species; bobby calves wear cattle devices,
            // so a Bobby Calves consignment must accept devices whose NLIS species is "Cattle".
            return 'Cattle';
    }
}
